"use client";

import { useState } from "react";

export type TErrors = Record<string, string>;

interface IUseErrors {
  errors: TErrors;
  hasError: (key: string) => boolean
  removeError: (key: string) => void;
  setErrors: (errors: TErrors) => void;
  getError: (key: string) => string | undefined
}

export default function useErrors(): IUseErrors {
  const [ errors, setErrors ] = useState<TErrors>({});

  const hasError = (key: string) => !!errors[key];

  const removeError = (key: string) => {
    const newErrors = errors;
    delete newErrors[key];

    setErrors(newErrors);
  };

  const getError = (key: string): string | undefined => errors[key];

  return {
    errors,
    setErrors,
    hasError,
    removeError,
    getError,
  };
}
